<template>
    <div>
        <preview-element-factory
            v-for="registrationData,index in registeredElements"
            :key = "registrationData.tempId ?  registrationData.tempId : registrationData.elementId"
            :registrationData="registrationData"
        ></preview-element-factory>
    </div>
</template>
<script>

    import PreviewElementFactory from "./PreviewElementFactory";
    import ElementsManager from "../../components/pagesbuilder/elements/ElementsManager";

    export default {
        name: "PreviewElementsManager",
        mixins: [ElementsManager],
        components: {
            PreviewElementFactory
        }
    }
</script>
